import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const values = [{
  title: 'Do the work properly.',
  description: 'Shortcuts tend to surface later. I would rather invest the additional time and be confident the work holds up to scrutiny.'
}, {
  title: 'Attend to the details.',
  description: 'In legal work, the details are the substance. A misread clause or a missed deadline can materially change an outcome, so precision matters.'
}, {
  title: 'Remember the people involved.',
  description: 'Whatever side of a matter you are working on, there is a real person or organization relying on it. I try never to lose sight of that.'
}];
export function Values() {
  return <section className="py-20 md:py-32 px-6 bg-cream-dark/30" data-id="element-119" data-mp="2xxvsy7sqdqnb">
      <div className="max-w-6xl mx-auto" data-id="element-120" data-mp="3bw2agdddhe0t">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start" data-id="element-121" data-mp="3bur3y5sjls60">
          {/* Left: anchor quote */}
          <FadeIn className="lg:col-span-5 lg:sticky lg:top-24" data-id="element-122" data-mp="3r3pyityo8cyg">
            <span className="text-sage font-medium tracking-widest uppercase text-xs mb-6 block" data-id="element-123" data-mp="3r5kfxyaqhmxs">
              How I Work
            </span>
            <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-charcoal italic leading-tight" data-id="element-124" data-mp="4wrpry3axbh3">
              "How you do anything
              <br data-id="element-125" data-mp="8zo9xt8hpfn5" />
              is how you do
              <br data-id="element-126" data-mp="dxhdeeiervjq" />
              <span className="text-amber" data-id="element-127" data-mp="dxzjs3ysbq5d">everything.</span>"
            </h2>
            <div className="h-px w-16 bg-amber/40 mt-8" data-id="element-128" data-mp="iw14sufrtzjh" />
            <p className="text-charcoal/60 text-sm font-light mt-4 max-w-xs" data-id="element-129" data-mp="iug9h2lmuckk">
              Three principles that guide my approach to legal work and to
              everything else.
            </p>
          </FadeIn>

          {/* Right: connected list of principles */}
          <div className="lg:col-span-7 relative" data-id="element-130" data-mp="woqsr4ev1ej8">
            {/* Connecting vertical line */}
            <div className="absolute left-[14px] top-2 bottom-2 w-px bg-amber/20" data-id="element-131" data-mp="11ntvgi7db8o1" />

            <StaggerContainer className="space-y-12" data-id="element-132" data-mp="2xp5eoe47uwny">
              {values.map((value, idx) => <StaggerItem key={idx} className="relative pl-12" data-id="element-133" data-mp="2tp4ppzjhr32n" data-mpi={idx}>
                  {/* Numbered marker */}
                  <div className="absolute left-0 top-0 w-[30px] h-[30px] rounded-full bg-cream border border-amber/40 flex items-center justify-center font-playfair text-amber text-sm" data-id="element-134" data-mp="37grvqr38jpym">
                    {idx + 1}
                  </div>
                  <h3 className="font-playfair text-xl md:text-3xl text-charcoal mb-3" data-id="element-135" data-mp="3hg0mzc6puqha">
                    {value.title}
                  </h3>
                  <p className="text-charcoal/70 font-light leading-relaxed text-base md:text-lg" data-id="element-136" data-mp="3qeug2sku8yq3">
                    {value.description}
                  </p>
                </StaggerItem>)}
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}